import { render } from "./StatGender.vue?vue&type=template&id=a9ee78ae&scoped=true&ts=true"
import script from "./StatGender.vue?vue&type=script&lang=ts"
export * from "./StatGender.vue?vue&type=script&lang=ts"

import "./StatGender.vue?vue&type=style&index=0&id=a9ee78ae&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ee78ae"]])

export default __exports__